var REFRESHTOKEN_COOKIE_NAME = "my-capitech-refresh-token";
var ACCESSTOKEN_COOKIE_NAME = "my-capitech-access-token";
var CLIENTID_COOKIE_NAME = "my-capitech-clientid";
var REMEMBERME_COOKIE_NAME = "my-capitech-remember-me";

var SIMPLOYER_APPID_COOKIE_NAME = "my-capitech-simployer-appid";
var SIMPLOYER_SCI_COOKIE_NAME = "my-capitech-simployer-sci";
var SIMPLOYER_SID_COOKIE_NAME = "my-capitech-simployer-sid";

function setCookie(name, value, expiration) {
	var expires = "";
	var expDate = new Date();

	if (expiration !== undefined) {
		if (expiration instanceof Date) {
			expDate = expiration;
		} else {
			expDate.setTime(expDate.getTime() + (expiration * 24 * 60 * 60 * 1000));
		}
		expires = "; expires=" + expDate.toUTCString();
	}
	
	var jsonValue = JSON.stringify(value || "");
	var cookie = name + "=" + jsonValue + expires + "; path=" + getCookiePath();
	document.cookie = cookie;
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			var val = c.substring(nameEQ.length, c.length);
			try {
				return JSON.parse(val);
			} catch (err) {
				return val;
			}
		}
	}
	return null;
}

function eraseCookie(name) {
	var expireDate = new Date(1970, 1, 1, 0, 0, 0, 0);
	document.cookie = name + '=; expires=' + expireDate.toUTCString() + ';path=' + getCookiePath();
}

function getCookiePath() {
	var path = window.location.pathname;
	var aPath = path.split('/');
	var isRoot = path === "/";
	if (isRoot === false) {
		// IF window.location.pathname contains filename
		var pathLastValue = aPath[aPath.length - 1];
		if (pathLastValue !== undefined && aPath[aPath.length - 1].indexOf(".") > -1) {
			aPath.splice(aPath.length - 1, 1);
		}
		// IF installation is in Capitech cloud
		if (aPath.length >= 4 && aPath[2] === "apps" && (aPath[3].toLowerCase().indexOf("mincapitech") > -1 || aPath[3].toLowerCase().indexOf("mycapitech") > -1))  {
			aPath.splice(2, 2);
		}
		// localStoragePath should always ends with /
		if (aPath[aPath.length - 1].length > 0) {
			aPath.push("");
		}
		var localStoragePath = aPath.join('/');
	} else {
		var localStoragePath = path;
	}
	return localStoragePath;
}